import React from 'react';
import {Button} from '@blueprintjs/core';
import { Link } from 'react-router';
import {validatable} from 'components/utils';
import { DatePicker, Input, InputTuKhoa, DropDown } from 'components/tt-forms/common';
import { ThanhTra } from 'api';
import { ShowIf } from 'components/utils';
import { get, isEmpty } from 'lodash';

let classNames = require('classnames');

class Search extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tenDoiTuongThanhTra: '',
      soQuyetDinh: '',
      loaiHinhThanhTra: '',
      phanLoai: '',
      linhVucThanhTra: '',
      tienDoThanhTra: '',
      soKetLuanThanhTra: '',
      soQuyetDinhXL: '',
      quyetDinhPheDuyetKHTT: '',
      tuNgay: '',
      denNgay: '',
      namThanhTra: '',
      searching: this.props.disabled,
      spSearch: false,
      doSearch: false,
      loaiHinhThanhTraList: [
      {
          giaTri: "THANH_TRA",
          ten: "Thanh tra"
      },
      {
          giaTri: "KIEM_TRA",
          ten: "Kiểm tra"
      }
    ],
      phanLoaiHinhThucCTTList: [],
      tienDoList: [],
      linhVucThanhTraList: [],
      listNamThanhTra: []
    }
  }

  async componentDidMount() {
    // this.getLoaiHinhThanhTra();
    await this.getNamThanhTraList();
    await this.checkNamThanhTraXuLy();
    this.getLinhVucThanhTra();
    this.getPhanLoaiHinhThucCTT();
    this.getTienDo();
  }

  // getLoaiHinhThanhTra() {
  //   ThanhTra.actions.getLoaiHinhThanhTra.request().then(res => {
  //     if (res.data) {
  //       this.state.loaiHinhThanhTraList = res.data;
  //     } else {
  //       this.state.loaiHinhThanhTraList = [];
  //     }
  //     this.setState({...this.state});
  //   });
  // }

  getPhanLoaiHinhThucCTT() {
    let state = this.state;
    ThanhTra.actions.nhomHinhThucCuocThanhTraPhanLoai.request().then(res => {
      if (res && res.data) {
        state.phanLoaiHinhThucCTTList = res.data;
      } else {
        state.phanLoaiHinhThucCTTList = [];
      }
      this.setState(state);
    });
  }

  getLinhVucThanhTra() {
    ThanhTra.actions.getLinhVucThanhTra.request().then(res => {
      if (res.data) {
        this.state.linhVucThanhTraList = res.data;
      } else {
        this.state.linhVucThanhTraList = [];
      }
      this.setState({...this.state});
    });
  }

  getTienDo() {
    ThanhTra.actions.getTienDoThanhTra.request().then(res => {
      if (res.data) {
        this.state.tienDoList = res.data;
      } else {
        this.state.tienDoList = [];
      }
      this.setState({...this.state});
    });
  }

  async checkNamThanhTraXuLy() {
    await ThanhTra.actions.getHienThiKeHoachThanhTra.request().then(async res => {
      if (!isEmpty(res.data)) {
        await this.setState({
          namThanhTra: get(res, 'data.namThanhTra')
        });
      }
    });
  }

  async getNamThanhTraList() {
    await ThanhTra.actions.getNamThanhTra.request().then(res => {
      if (!isEmpty(res.data)) {
        this.setState({
          listNamThanhTra: get(res, 'data')
        });
      }
    });
  }

  handleSearch(e) {
    e.preventDefault();
    this.props.handleSearch(this.state, e);
  }

  componentWillUnmount() {

  }

  cancel(e) {
    this.props.onCancel(e);
    this.resetData();
  }

  handleChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      searching: nextProps.disabled,
      doSearch: nextProps.search
    });
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  resetData() {
    let state = this.state;
    state.tenDoiTuongThanhTra = '';
    state.soQuyetDinh = '';
    state.loaiHinhThanhTra = '';
    state.phanLoai = '';
    state.linhVucThanhTra = '';
    state.tienDoThanhTra = '';
    state.soKetLuanThanhTra = '';
    state.soQuyetDinhXL = '';
    state.quyetDinhPheDuyetKHTT = '';
    state.tuNgay = '';
    state.denNgay = '';
    state.searching = false;
    state.spSearch = false;
    state.doSearch = false;
    this.setState(state);
  }
  render() {
    let classes = ['btn-green', 'tt-search'];

    if (this.state.searching) {
      classes.push('btn-disable');
    }
    if (this.state.doSearch) {
      classes.push('btn-loading');
    }

    let btnClasses = classNames(classes);
    return (
      <form className={this.props.advanceSearch ? "search-form" : "search-form-default"} onSubmit={ this.handleSearch.bind(this) }>
        <div className={this.props.advanceSearch ? 'col-83' : 'col-80'}>
          <Input className='col-60' label="Đối tượng thanh tra/kiểm tra" placeholder="Nhập tên đối tượng thanh tra, kiểm tra..." value={this.state.tenDoiTuongThanhTra} onChange={this.handleChange.bind(this, 'tenDoiTuongThanhTra')} name='tenDoiTuongThanhTra' />
          <DropDown className='col-40' label="Năm thanh tra/kiểm tra" options={this.state.listNamThanhTra} keyName="giaTri" valueName="ten" selectedValue={this.state.namThanhTra} onChange={this.handleChange.bind(this, 'namThanhTra')} placeholder />
          <ShowIf condition={this.props.advanceSearch}>
            <div className='col-100 no-gutter'>
              <DropDown label="Loại hình thanh tra/kiểm tra" selectedValue={this.state.loaiHinhThanhTra} placeholder className="col-25" onChange={this.handleChange.bind(this, 'loaiHinhThanhTra')} name='loaiHinhThanhTra'
              options={this.state.loaiHinhThanhTraList} keyName="giaTri" valueName="ten"/>
              <Input label="Số quyết định" value={this.state.soQuyetDinh}  className="col-25" onChange={this.handleChange.bind(this, 'soQuyetDinh')} name='soQuyetDinh' placeholder="Nhập..." maxLength={255}/>
              <DropDown label="Phân loại" selectedValue={this.state.phanLoai} placeholder className="col-25" onChange={this.handleChange.bind(this, 'phanLoai')} name='phanLoai'
              options={this.state.phanLoaiHinhThucCTTList} keyName="giaTri" valueName="ten"/>
              <DropDown label="Tiến độ" placeholder selectedValue={this.state.tienDoThanhTra} className="col-25" onChange={this.handleChange.bind(this, 'tienDoThanhTra')} name='tienDoThanhTra' options={this.state.tienDoList} keyName="giaTri" valueName="ten" />
            </div>
          </ShowIf>
        </div>
        {
          this.props.advanceSearch ? (
            <div className="col-16 mt25">
              <Button className={ btnClasses } text="Tìm kiếm" type="submit" disabled={ this.state.searching ? 'disabled' : '' } />
            </div>
          ) : (
            <div className="btn-wrap-default">
              <Button className={ btnClasses } text="Tìm kiếm" type="submit" disabled={ this.state.searching ? 'disabled' : '' } />
            </div>
          )
        }
        <ShowIf condition={this.props.advanceSearch}>
          <div className='col-83'>
            <DatePicker className="col-25" label='Quyết định ra từ ngày' bindValidator={this} channel="formTaoDon" endDate={ this.state.denNgay } onChange={ this.handleChangeDate.bind(this, 'tuNgay')} value={this.state.tuNgay} name='tuNgay' />
            <DatePicker className="col-25" label='Đến ngày' bindValidator={this} channel="formTaoDon" startDate={ this.state.tuNgay } onChange={ this.handleChangeDate.bind(this, 'denNgay')} value={this.state.denNgay} name='denNgay' />
            <Input label="Số kết luận TT/KT" value={this.state.soKetLuanThanhTra}  className="col-25" onChange={this.handleChange.bind(this, 'soKetLuanThanhTra')} name='soKetLuanThanhTra' placeholder="Nhập..." maxLength={255}/>
            <Input label="Số quyết định XL" value={this.state.soQuyetDinhXL}  className="col-25" onChange={this.handleChange.bind(this, 'soQuyetDinhXL')} name='soQuyetDinhXL' placeholder="Nhập..." maxLength={255}/>
          </div>
          <div className="col-16">
            <Link
            className={ this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search" }
            onClick={ this.cancel.bind(this) }>
              <i className="tt tt-delete"></i>Hủy tìm kiếm nâng cao
            </Link>
          </div>
        </ShowIf>
      </form>
    );
  }
}

Search.defaultProps = {
  validators: {},
  handleSearch: function() {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false
}

export default validatable(Search);


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/sub-view/Search.jsx